// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const GeneralErrorViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-generalErrorView" */ "./GeneralErrorView")).then((bundle)=>{
        return {
            default: bundle.GeneralErrorView
        };
    });
export const LazyGeneralErrorView = /*#__PURE__*/ lazy(GeneralErrorViewLazyLoader);
